import { Box, Typography } from '@mui/material';
import { WeeklySummaryCards } from '../../components/patient';
import patientHomeData from '../../mocks/patientHome.json';

interface InsightCard {
  id: string;
  cardType: string;
  title: string;
  summary: string;
  confidence: number;
  status: "NEW" | "VIEWED" | "RESOLVED";
  createdAt: string;
}

export const ProgressPage = () => {
  // Adapt insights to match InsightCard interface
  const insights: InsightCard[] = patientHomeData.insights.map((insight: {
    id: string;
    insightType: string;
    title: string;
    summary: string;
    viewedByPatient: boolean;
    createdAt: string;
  }) => ({
    id: insight.id,
    cardType: insight.insightType,
    title: insight.title,
    summary: insight.summary,
    confidence: 0.85, // Mock confidence
    status: (insight.viewedByPatient ? "VIEWED" : "NEW") as "NEW" | "VIEWED" | "RESOLVED",
    createdAt: insight.createdAt
  }));

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        My Progress
      </Typography>
      <Typography color="text.secondary" paragraph>
        Here are your recent insights and progress updates.
      </Typography>

      <WeeklySummaryCards insights={insights} />
    </Box>
  );
};
